module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-mazda.cc63d335.png";